import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";

/** Same tables risk-pricing-engine's own lib/api/reference.ts reads
 *  (athena_bfsi_rbp.office / blended_net_rav / annualized_loss_calibiration),
 *  scoped under /weighted-average-life since this app has no shared
 *  reference-list endpoints. */
export interface Office {
  officeNumber: number;
  officeName: string;
}

export function useWalOffices() {
  return useQuery({
    queryKey: ["pp-wal", "offices"] as const,
    queryFn: () => apiGet<Office[]>("/weighted-average-life/offices"),
    staleTime: 5 * 60_000,
  });
}

